import React from 'react';

import { ModelTable } from '../../../components';
import { Column, Image } from '@smartplatform/ui';

export const CityList = ({ rootPath, tabName }) => {
	const options = { include: ['division', 'district'] };
	return (
		<ModelTable
			model="City"
			options={options}
			rootPath={rootPath}
			path={'/admin/divisions/cities'}
			tabName={tabName}
			limit={20}
			showAddButton={false}
		>
			<Column property="name" label="Название" />
			<Column relation="district" property="name" label="Улус" />
			<Column relation="division" property="name" label="Избирательный округ" />
		</ModelTable>
	);
};
